
import AppListItem from '@components/new-styleguide/AppListItem.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';

const MembershipModule = namespace('Membership');

  @Component({
    name: 'TripMissingField',
    components: {
      AppListItem,
      CircleIcon
    },
  })
export default class TripMissingField extends Vue {
    @Prop() odometerStart: number

    @Prop() odometerEnd: number

    @Prop() prevTripId: number

    @Prop() nextTripId: number

    @Prop() connection: boolean

    @Prop() vehicleId: number;

    @MembershipModule.Getter('hasValidMembership') hasValidMembership;

    get value() {
      return { title: `Hier fehlen ${this.missingKilometres} km!`, hasButton: true,
        tagIcon: { value: 'tag_danger_icon', fillId: 'oeamtc-gradient__danger', fill: 'white'} };
    }

    get missingKilometres() {
      return Math.round((this.odometerEnd - this.odometerStart) * 10) / 10;
    }
}
